<h1 mat-dialog-title>Bulk location Creation</h1>

<div mat-dialog-content>
  <form [formGroup]="importForm" class="form-container">
    <div class="left-column">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Dialog.Locations.BillableOrg' | translate }}</mat-label>
        <input matInput
               formControlName="billableOrg"
               readonly>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'Dialog.Locations.OrganizationName' | translate }}</mat-label>
        <mat-select formControlName="organizationName" required>
          <mat-option *ngFor="let org of orgList" [value]="org.value">
            {{ org.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'Dialog.Locations.TimeZone' | translate }}</mat-label>
        <mat-select formControlName="timeZone" required>
          <mat-option *ngFor="let timeZone of timeZoneOptions$ | async" [value]="timeZone.value">
            {{ timeZone.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="right-column">
      <input #fileInput
             type="file"
             (change)="onFileSelected($event)"
             accept=".xlsx,.xls"
             style="display: none">

      <div class="file-upload-area">
        <div class="droparea"
             [ngClass]="{
               'has-file': selectedFileName,
               'dragging': isDragging
             }"
             (click)="fileInput.click()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)">

          <svg-icon class="upload-icon" src="assets/svg/clip-icon.svg"></svg-icon>

          <div *ngIf="!selectedFileName" class="upload-content">
            <div class="text-dropzone-primary">Accepted file formats: .xlx or .xlsx</div>
            <div class="text-dropzone-secondary">Use the provided Template file to enter the Required fields:</div>
            <div class="text-dropzone-tertiary">Location Name, Address1, City, Country  </div>
          </div>

          <div *ngIf="selectedFileName" class="file-selected-content">
            <div class="text-dropzone-primary">{{ 'Dialog.Locations.SelectedFileName' | translate }}</div>
            <div class="text-dropzone-secondary">{{ selectedFileName }}</div>
            <button mat-stroked-button
                    color="warn"
                    (click)="removeSelectedFile()"
                    class="delete-file-btn"
                    type="button">
              Remove File
            </button>
          </div>
        </div>

        <!-- File Information Section -->
        <div *ngIf="selectedFileName" class="file-info-container">
          <div class="file-info-field">
            <label class="file-info-label">File Name:</label>
            <span class="file-info-value">{{ selectedFileName }}</span>
          </div>
          <div class="file-info-field">
            <label class="file-info-label">File Date:</label>
            <span class="file-info-value">{{ fileDate | date:'medium' }}</span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()" type="button">
    {{ 'Dialog.Cancel' | translate }}
  </button>
  <button mat-raised-button
          color="primary"
          (click)="onImportClick()"
          [disabled]="importForm.invalid || !selectedFileName"
          type="button">
    Preview File Content
  </button>
</div>
